import React from 'react';
import { Col, Container, FormGroup, Label, Row } from 'reactstrap';
import { Field, Fields } from 'redux-form';
import { compact } from 'underscore';

// components
import BufferedInput from '../../../components/form/field/buffered-input';
import CommercialTypeFilter from '../../../components/form/filter/commercial-type-filter';
import SaleFilter from '../../../components/form/filter/sale-filter';
import PriceFilter from '../../../components/form/filter/price-filter';
import { LocationTypeAheadField } from '../../../components/form/field/location-typeahead';
import BuildingTypeFilter from '../../../components/form/filter/building-type-filter';
import SQFTFilter from '../../../components/form/filter/sqft-filter';
import PreferenceFilter from '../../../components/form/filter/preference-filter';
import WaterfrontTypeFilter from '../../../components/form/filter/waterfront-type-filter';

// modules
import BS from '../../../theme/Bootstrap';
import formStyles from '../../../components/form/form.module.scss';
import styles from '../../Containers.module.scss';

const CommercialAdvancedSearch = props => {
  return (
    <Container className={`${BS.alignItemsStart}`}>
      <Row>
        <Col xs={12} md={4}>
          <FormGroup>
            <Label className={styles.label} for="address">
              Location:
            </Label>
            <LocationTypeAheadField name="address" propertyClass="commercial" />
          </FormGroup>
          <FormGroup className={formStyles.inputTextCenter}>
            <Label className={styles.label} for="minPrice">
              Price:
            </Label>
            <Fields
              names={['minPrice', 'maxPrice']}
              component={PriceFilter}
              showSelects
            />
          </FormGroup>
          <FormGroup className={formStyles.inputTextCenter}>
            <Label className={styles.label} for="minArea">
              Subject Sq. Ft.:
            </Label>
            <Fields names={['minArea', 'maxArea']} component={SQFTFilter} />
          </FormGroup>
          <FormGroup className={formStyles.inputTextCenter}>
            <Label className={styles.label} for="minLandArea">
              Land Sq Ft.:
            </Label>
            <Fields names={['minLandArea', 'maxLandArea']} component={SQFTFilter} />
          </FormGroup>
        </Col>
      </Row>
      <FormGroup row>
        <Col xs={12} md={4}>
          <Label className={styles.label} for="location">
            MLS ID:
          </Label>
          <div>
            <Field
              name="mlsNumber"
              type="text"
              placeholder="MLS ID"
              component={BufferedInput}
            />
          </div>
        </Col>
      </FormGroup>
      <FormGroup>
        <Label className={styles.label} for="transactionType">
          Transaction Type:
        </Label>
        <div>
          <Field
            format={value => {
              return compact((value || '').trim().split(','));
            }}
            normalize={value => {
              return value.join(',');
            }}
            name="transactionType"
            component={SaleFilter}
          />
        </div>
      </FormGroup>
      <FormGroup>
        <Label className={styles.label} for="commercialType">
          Commercial Type:
        </Label>
        <div>
          <Field
            format={value => {
              return compact((value || '').trim().split(','));
            }}
            normalize={value => {
              return value.join(',');
            }}
            name="commercialType"
            component={CommercialTypeFilter}
          />
        </div>
      </FormGroup>
      <FormGroup>
        <Label className={styles.label} for="buildingType">
          Property Type:
        </Label>
        <div>
          <Field
            format={value => {
              return compact((value || '').trim().split(','));
            }}
            normalize={value => {
              return value.join(',');
            }}
            name="buildingType"
            component={BuildingTypeFilter}
            type="commercial"
          />
        </div>
      </FormGroup>
      <Row>
        <Col xs={12} md={4}>
          <FormGroup>
            <Label className={styles.label} for="waterfrontYN">
              Waterfront:
            </Label>
            <Field name="waterfrontYN" component={PreferenceFilter} />
          </FormGroup>
        </Col>
      </Row>
      <FormGroup>
        <Label className={styles.label} for="waterfront">
          Waterfront Description:
        </Label>
        <div>
          <Field
            format={value => {
              return compact((value || '').trim().split(','));
            }}
            normalize={value => {
              return value.join(',');
            }}
            name="waterfront"
            component={WaterfrontTypeFilter}
          />
        </div>
      </FormGroup>
    </Container>
  );
};

export default CommercialAdvancedSearch;



// WEBPACK FOOTER //
// ./src/containers/PropertySearch/AdvancedSearch/CommercialAdvancedSearch.js